import { createFileRoute } from "@tanstack/react-router";
import { queries } from "@theprelude/core";
import { z } from "zod";
import { setPageTitle } from "@/components/app-shell/app-shell";
import { ExecutiveSummary } from "@/components/executive-summary/executive-summary";
import { authorizeFeatures } from "@/lib/authorize-feature";

const executiveSummarySchema = z.object({
  tabs: z
    .array(z.enum(["endpoint", "user", "email"]))
    .optional()
    .catch([]),
});

export type ExecutiveSummaryTab = NonNullable<
  z.infer<typeof executiveSummarySchema>["tabs"]
>[number];

export const Route = createFileRoute("/_app/executive-summary")({
  beforeLoad: () => setPageTitle("Executive Summary"),
  loader: async ({ context }) => {
    await authorizeFeatures(context, ["policy_evaluator"]);
    const authConfig = await context.auth.getAuthConfig();

    await Promise.all([
      context.queryClient.ensureQueryData(queries.iam.getAccount(authConfig)),
      context.queryClient.ensureQueryData(queries.scm.summary(authConfig)),
    ]);
  },
  component: ExecutiveSummaryPage,
  validateSearch: executiveSummarySchema,
});

function ExecutiveSummaryPage() {
  const { tabs = [] } = Route.useSearch();
  return <ExecutiveSummary activeTabs={tabs} />;
}
